module.exports = __webpack_public_path__ + "img/word4.60da9988.png";